import { IRulerInfo } from '@/editor/entities/2d/rulerModel';
import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { IPoint2d } from '@/editor/math/IPoint2d';

export function getArcWallRulerInfos(mainWallData: {
  start: IPoint2d;
  end: IPoint2d;
  center: IPoint2d;
  clockwise: boolean;
}): {
  chordRuler: IRulerInfo;
  sagittaRuler: IRulerInfo;
} {
  const arcSeg = new ArcSeg2d(mainWallData);
  const sagitta = arcSeg.getSagitta();

  return {
    chordRuler: {
      id: 'chordRuler',
      start: sagitta > 0 ? mainWallData.end : mainWallData.start,
      end: sagitta > 0 ? mainWallData.start : mainWallData.end
    },
    sagittaRuler: {
      id: 'sagittaRuler',
      start: mainWallData.start,
      end: mainWallData.end,
      center: mainWallData.center,
      clockwise: mainWallData.clockwise,
      offset: 0
    }
  };
}
